'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kebabCase = require('lodash/kebabCase');

var _kebabCase2 = _interopRequireDefault(_kebabCase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slugify = function slugify(text) {
  return (0, _kebabCase2.default)(text);
};

exports.default = slugify;
//# sourceMappingURL=slugify.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/feedback/lib/cjs/util/slugify.js
 ** module id = 727
 ** module chunks = 1
 **/